import { createPinia } from 'pinia';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import { useRootStore } from './root';

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

export {
    // Pinia instance for registration in app:
    pinia,
    // Composables for accessing individual stores:
    useRootStore
};
